<template>
	<div>
		<div v-if="isUserAllowedInLevel1 || isAuthenticatedUserInGroupAdmin">
			<BaseHeader :title="getTitle">
				<div class="flex items-center">
					<BaseButton class="btn-blue" @click="$router.push({ name: 'NewUserprofile' })" v-if="!this.$route.params.id">{{
						$t('add_employee')
					}}</BaseButton>
				</div>
			</BaseHeader>
			<div class="main">
				<div class="flex justify-between">
					<BaseSelect :filter-only="true" v-model="filter" :options="filterOptions" class="w-56" label="Filter" />
				</div>

				<div v-if="employees">
					<div class="flex flex-col">
						<div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
							<div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
								<div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
									<table class="min-w-full divide-y divide-gray-200">
										<thead>
											<tr>
												<th
													v-for="header in getHeader"
													:key="header.name"
													:class="header.class"
													class="py-3 bg-gray-50 text-left text-sm leading-4 font-medium text-gray-500 uppercase tracking-wider"
												>
													{{ header.name }}
												</th>
											</tr>
										</thead>
										<tbody class="bg-white divide-y divide-gray-200">
											<EmployeeRow
												v-for="employee in getEmployees"
												:key="employee.id"
												:employee="employee"
												@delete="updateEmployees"
												:show-employee-is-enabled="filter === filterOptions[2]"
											/>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div v-else>
					<LoadingSpinner />
				</div>
				<div v-if="$route.params.backlink" class="mt-8 mb-8 flex justify-between">
					<BaseButton @click="$router.push($route.params.backlink)" class="mr-4">{{ $t('general.back') }}</BaseButton>
				</div>
			</div>
		</div>
		<div v-else>
			<Forbidden />
		</div>
		<router-view />
	</div>
</template>

<script>
import BaseHeader from '@/components/navigation/BaseHeader';
import EmployeeRow from '@/components/rows/EmployeeRow';
import { CompanyApiFactory, UserApiFactory } from '@/api/generated';
import apiDefaults from '@/api/defaultConfiguration';
import BaseButton from '@/components/forms/buttons/BaseButton';
import BaseSelect from '@/components/forms/inputs/BaseSelect';
import LoadingSpinner from '@/components/navigation/LoadingSpinner';
import Authentication from '@/mixins/Authentication';
import Forbidden from '@/views/default/Forbidden';
import RouteWatcher from '@/mixins/RouteWatcher';

export default {
	name: 'Employees',
	components: { Forbidden, LoadingSpinner, BaseSelect, BaseButton, EmployeeRow, BaseHeader },
	mixins: [Authentication, RouteWatcher],
	data() {
		return {
			employees: '',
			company: null,
			companyID: '',
			filterOptions: [
				{
					display: this.$t('active'),
					value: 'enabled',
				},
				{
					display: this.$t('disabled'),
					value: 'disabled',
				},
				{
					display: this.$t('all'),
					value: 'all',
				},
			],
			filter: {
				display: this.$t('active'),
				value: 'enabled',
			},
		};
	},
	methods: {
		onRouteChange() {
			this.company = null;
			this.employees = null;
			this.updateEmployees();
		},
		updateEmployees() {
			if (this.$route.params.id) {
				const companyApiFactory = CompanyApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios);
				companyApiFactory.companyIdEmployeesGet(this.$route.params.id).then(response => {
					this.employees = response.data.data;
				});
				companyApiFactory.companyIdGet(this.$route.params.id).then(response => {
					this.company = response.data;
				});
			} else {
				UserApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
					.userGet()
					.then(response => {
						this.employees = response.data;
					});
			}
		},
	},
	computed: {
		getTitle() {
			return this.$route.params.id && this.company?.name ? this.$t('employee_of') + ' ' + this.company.name : this.$t('employee');
		},
		getEnabledEmployees() {
			return this.employees.filter(employee => employee.is_enabled);
		},
		getDisabledEmployees() {
			return this.employees.filter(employee => !employee.is_enabled);
		},
		getEmployees() {
			let employees;
			switch (this.filter.value) {
				case 'enabled':
					employees = this.getEnabledEmployees;
					break;
				case 'disabled':
					employees = this.getDisabledEmployees;
					break;
				default:
					employees = this.employees;
					break;
			}

			return employees;
		},
		getHeader() {
			const header = [];
			header.push({ name: 'Name', class: 'px-6' });
			header.push({ name: 'Firma', class: 'px-6' });
			header.push({ name: 'Zeit', class: 'px-6' });
			header.push({ name: 'Autor', class: 'px-6' });
			header.push({ name: 'Zuletzt gesehen', class: 'px-6' });
			header.push({ name: 'Logins', class: 'px-6' });

			if (this.filter === this.filterOptions[2]) {
				header.push({ name: 'Aktiv', class: 'px-6' });
			}

			return header;
		},
	},
};
</script>
